import Experience from "../Experience.js"
import Environment from './Environment.js'
import KasekiW from './KasekiW.js'
import KasekiC from './KasekiC.js'
import KasekiL from './KasekiL.js'
import KasekiR from './KasekiR.js'

export default class World
{
    constructor()
    {
        this.experience = new Experience()
        this.scene = this.experience.scene
        this.resouces = this.experience.resources


        //

        // Wait for resources
        this.resouces.on('ready', () =>
        {
            // Setup
            this.kasekiW = new KasekiW()
            this.kasekiC = new KasekiC()
            this.kasekiL = new KasekiL()
            this.kasekiR = new KasekiR()
            this.environment = new Environment()
        })
    }

    update()
    {
        if(this.kasekiC)
            this.kasekiC.update()
        if(this.kasekiL)
            this.kasekiL.update()
        if(this.kasekiR)
            this.kasekiR.update()
    }
}